<ng-container [formGroup]="GenForm">

<ng-container *ngIf="es.ExamType!=='Pulmonary functional assessment' && es.ExamType!=='Methacholine test'">
    
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">

        <!-- cell : Anamnesis -->

        <div class="w50 summary-anamnesis" style="height: 50%;" *ngIf="es.ExamType !== 'Stress' && es.ExamType !== 'Holter ECG'">

            <section class="m-box">

                <h2>
                    Medical History
                </h2>

                <button class="t-btn-smart" *ngIf="!es.isClosed && ls.hasPremission('Questionnaires')"
                    [disabled]="aiSummaryLoading" style="margin-bottom: 0.5em" (click)="getAiSummary('MedicalHistory')">{{ 'GUI.General.Buttons.Populate Smart History' | translate }}
                    <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
                </button>
                <textarea class="scroller" formControlName="MedicalHistory">

                </textarea><!-- /scroller -->
                <button class="t-btn-edit" *ngIf="! es.isClosed && lastMed" (click)="addLastMed()"
                    style="margin-right: 6em">Previous Medical History</button>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(GenForm.get('MedicalHistory')!,'Medical History',(es.ExamType === 'TTE Pediatric' ?2000:1))">Auto Text</button>

            </section>

        </div>
        <!-- endcell : Anamnesis -->

        <!-- cell : Reason for Examinanion -->

        <div class="w50 summary-recommendations" style="height: 50%;">

            <section class="m-box">

                <h2>
                    Reason for Examination
                </h2>

                <textarea class="scroller" formControlName="Purpose">

                </textarea><!-- /scroller -->

                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(GenForm.get('Purpose')!,'Reason for Examinanion',(es.ExamType === 'TTE Pediatric' ?2001:92))">Auto Text</button>

            </section>

        </div>

        <!-- endcell : Reason for Examinanion -->
        <!-- cell : Risk Factors -->

        <div class="w50 summary-recommendations" style="height: 50%;" *ngIf="es.ExamType === 'Stress' || es.ExamType === 'Holter ECG'">

            <section class="m-box">

                <h2>
                    Medical Hx  and risk factors 
                </h2>

                <button class="t-btn-smart" *ngIf="!es.isClosed && ls.hasPremission('Questionnaires')"
                    [disabled]="aiSummaryLoading" style="margin-bottom: 0.5em" (click)="getAiSummary('Risk')">{{ 'GUI.General.Buttons.Populate Smart History' | translate }}
                    <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
                </button>
                <textarea class="scroller" formControlName="Risk">

                </textarea><!-- /scroller -->

                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(GenForm.get('Risk')!,'Risk Factors ',(es.ExamType === 'Stress' ? 501 : 2501))">Auto Text</button>

            </section>

        </div>
             <!-- cell : Medications -->
        <!-- <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary" [ngClass]="es.ExamType == 'Stress' ? 'w50' : 'w100'"> -->

            <div class="summary-recommendations w50" *ngIf="es.ExamType === 'Stress' || es.ExamType === 'Holter ECG'">

                <section class="m-box" style="height: 100%;">

                    <h2>Medications</h2>

                    <textarea class="scroller" formControlName="Medications" style="height: 100%;">

                    </textarea><!-- /scroller -->

                    <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(GenForm.get('Medications')!,'Medications ',(es.ExamType === 'Stress' ? 502 : 2502))">Auto Text</button>

                </section>

            </div>

        <!-- </div> -->

        <!-- endcell : Medications -->
                <!-- cell : Imaging Quality && HMO -->
        <!-- <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary" [ngClass]="es.ExamType == 'Stress' ? 'w50' : 'w100'"> -->
            <div class="summary-recommendations" [ngClass]="(es.ExamType === 'Stress' || es.ExamType === 'Holter ECG') ? 'w50' : 'w100 l-flex'">
                <div class="m-box" *ngIf="es.ExamType !== 'Stress' && es.ExamType !== 'Holter ECG'"  [ngClass]="(es.ExamType === 'Stress' || es.ExamType === 'Holter ECG') ? '' : 'w50 w50-marg'" (dblclick)="GenForm.get('Quality')?.setValue(-1)">

                    <h2>
                        Imaging Quality
                    </h2>

                    <div class="l-flex-c l-flex-w indicative-fieldset h100" style="justify-content: space-evenly">
                        <label class="t-label-top">

                            <input type="radio" formControlName="Quality" value="Technically limited" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Technically limited
                            </span>

                        </label>

                        <label class="t-label-top">
                            <input type="radio" formControlName="Quality" value="Fair" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Fair
                            </span>
                        </label>

                        <label class="t-label-top">
                            <input type="radio" formControlName="Quality" value="Good" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Good
                            </span>
                        </label>
                    </div>

                </div>
                <section class="m-box" [ngClass]="(es.ExamType === 'Stress' || es.ExamType === 'Holter ECG') ? '' : 'w50'"  (dblclick)="GenForm.get('HMO')?.setValue(-1)">
        
                    <h2>
                        HMO
                    </h2>
                    <div class="l-flex-c l-flex-w indicative-fieldset h100" style="justify-content: space-evenly">
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Clalit
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Macabi
                            </span>
                        </label>

                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Meuhedet
                            </span>
                        </label>
                        <label class="t-label-top">

                            <input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Leumit
                            </span>

                        </label>

                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Private
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="הפניקס" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Phoenix
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="כלל" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Clal
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="איילון" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Ayalon
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="הכשרה ביטוח" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Hachshara Insurance
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="מנורה" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Menora
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="מגדל" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Migdal
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="HMO" value="IDF" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                IDF
                            </span>
                        </label>


                    </div>
                    <app-financial-status [examId]="es.examID"></app-financial-status>
                </section>
            </div>
            <!-- <div class="w50 summary-recommendations">


            </div> -->
    <!-- </div> -->
        <!-- endcell : Imaging Quality && HMO  -->

        <!-- endcell : Risk Factors -->

    </div>
    <!-- box (start) -->
    <section class="m-box" style="margin-top: 2em;" *ngIf="es.ExamType == 'TTE Adults'">

        <h2>
            Study
        </h2>

        <div class="w100 placenta-ammiotic">

            <!-- row (start) -->
            <div class="l-flex-c l-flex-w l-justify h50 placenta-row">
                <label class="t-label-top" *ngIf="es.ExamType =='TTE Adults'">
                    <app-geninput [form]="GenForm.get('ECG')" fieldnum="1" title="Resting ECG Rythm"></app-geninput>
                </label>

                <label class="t-label-top">
                    <span>
                        Heart Rate
                    </span>
                    <span class="t-field t-field--number">
                        <input class="t-field-text" type="number" min="0" formControlName="HeartRate" />
                        <span class="t-field-desc">
                            bpm
                        </span>
                    </span>
                </label>

                <label class="t-label-top">
                    <span>
                        Blood Pressure
                    </span>
                    <span class="t-field t-field--number" style="max-width: fit-content">
                        <input class="t-field-text" type="number" min="0" formControlName="bpSystolic"
                            style='width: 4em' />/<input class="t-field-text" type="number" min="0"
                            formControlName="bpDiastolic" style='width: 4em'>
                        <span class="t-field-desc">
                            mmHg
                        </span>
                    </span>
                </label>


            </div>
            <!-- row (end) -->


        </div>

    </section>
    <!-- box (end) -->
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary " style='padding-bottom: 1em;margin-top: 1em;'>
        <div class="w50">
            <div class="m-box">

                <h2>
                    Referring Doctor
                </h2>

                <textarea class="fulltext t-field" style="width: 100%; padding-left: 0.5em;height: 2em" formControlName="ReferingDoc"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(GenForm.get('ReferingDoc')!,'Referring Doctor',(es.ExamType === 'TTE Pediatric' ?2002:3))">Auto Text</button>

                    <div class="l-flex-c h100" style="direction: rtl;display: block;">
                        <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                            מספר הפניה
                            <input class="t-field" formControlName="ReferralNum" style='width: 8em;padding-left:0.5em'>
                        </div>
                        <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                            ת.ז רופא מפנה
    
                            <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="RefererringDocID">
                       
                        </div>
                        <!-- Clalit routes the result to the referring doctor's license and clinic (the barcodes on its referral) -->
                        <ng-container *ngIf="GenForm.get('HMO')?.value == 'Clalit'">
                            <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                                רישיון רופא מפנה
                                <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="ReferringDocLicense">
                            </div>
                            <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                                גורם שולח (קוד מרפאה)
                                <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="ReferringClinicCode">
                            </div>
                            <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                                שם מרפאה מפנה
                                <input type="text" class="t-field" style='width: 12em;padding-left:0.5em' formControlName="ReferringClinicName">
                            </div>
                        </ng-container>

                    </div>
            </div>
        </div>
        <div class="w50">
            <section class="m-box">

                <div class="l-flex-c h100">

                    <div class="l-fg1 repeatExamination-text" style="font-size: 1.05em;">
                        Schedule Followup
                        <select class="t-select t-field" formControlName="FollowUpExam">
                            <option default [ngValue]="null"></option>
                            <option value="TTE Adults">TTE Adults</option>
                            <option value="TTE Pediatric">TTE Pediatric</option>
                            <option value="Stress-Echo">Stress-Echo</option>
                            <option value="Duplex Carotid">Duplex Carotid</option>
                            <option value="Stress">Stress</option>
                            <option value="Holter ECG ">Holter ECG</option>
                        </select>
                        in

                        <span class="t-highlight-glowingCircle">
                            <input type="number" min="1" max="40"
                                style='width: 2em; background: none; border: none; color: white; font-size: 1.1em;margin-left: .7em;'
                                formControlName="Repeat1">
                        </span>

                        <select class="t-select t-field" formControlName="Repeat2">
                            <option></option>
                            <option value="days">Days</option>
                            <option value="weeks">Weeks</option>
                            <option value="months">Months</option>
                        </select>
                    </div>
                </div>

            </section>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="es.ExamType=='Pulmonary functional assessment' || es.ExamType=='Methacholine test'">
    <div class="h100 l-flex-w summary" style="margin-bottom: 1em;" >
    <div class="w49 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;">
        <div class="m-box" style="padding: 0;">
            <h2>Technician`s Comments</h2>
            <textarea class="scroller" style="height: 3vh;" formControlName="TechniciansComments"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('TechniciansComments')!,'Technician`sComments',1234)">Auto
            Text</button>
        </div>
    </div>
    <div class="w49 summary-anamnesis summary"  style="margin-bottom: 1em;">
        <div class="m-box" style="padding: 0;">
            <h2>Referral request</h2>
            <textarea class="scroller" style="height: 3vh;" formControlName="ReferralRequest"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('ReferralRequest')!,'Referral request',1235)">Auto
            Text</button>
        </div>
    </div>
    <div class="w100 summary-anamnesis" style="margin-bottom: 1em;">
    <div class="m-box">
        <h2>Findings</h2>

   <div style="display: flex;flex-wrap: wrap;padding-top: 1em;">
    <div class="w38 summary-anamnesis summary"   style="margin-bottom: 1em;margin-right: 1em;">
        <div class="m-box">
            <h2>Lung Volumes</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="LungVolumes"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('LungVolumes')!,'Lung Volumes',1237)">Auto
            Text</button>
        </div>
    </div>
    <div class="w20 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;">
        <div class="m-box">
            <h2>O2 saturation</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="O2Saturation"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('O2Saturation')!,'O2 saturation',1238)">Auto
            Text</button>
        </div>
    </div>
    <div class="w38 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;">
        <div class="m-box">
            <h2>Mechanics of breathing</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="MechanicBreathing"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('MechanicBreathing')!,'Mechanics of breathing',1236)">Auto
            Text</button>
        </div>
    </div>
    <div class="w32 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;" *ngIf="es.ExamType=='Pulmonary functional assessment'">
        <div class="m-box">
            <h2>Effort Test</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="EffortTest"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('EffortTest')!,'Effort Test',1242)">Auto
            Text</button>
        </div>
    </div>
    <div class="w32 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;" *ngIf="es.ExamType=='Methacholine test'">
        <div class="m-box">
            <h2>Methacholine challenge</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="MethacholineChallenge"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('MethacholineChallenge')!,'Methacholine challenge',1243)">Auto
            Text</button>
        </div>
    </div>
    <div class="w32 summary-anamnesis summary"  style="margin-bottom: 1em;margin-right: 1em;">
        <div class="m-box">
            <h2>Diffusion test</h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="DiffusionTest"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('DiffusionTest')!,'Diffusion test',1239)">Auto
            Text</button>
        </div>
    </div>
    <div class="summary-anamnesis summary"  style="margin-bottom: 1em;width: 32%;">
        <div class="m-box">
            <h2>Broncho dilatators reaction </h2>
            <textarea class="scroller" style="height: 10vh;" formControlName="BronchoDilatatorsReaction"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('BronchoDilatatorsReaction')!,'Broncho dilatators reaction ',1240)">Auto
            Text</button>
        </div>
    </div>
   </div>
</div>
</div>
    <div class='w100' style="margin-bottom: 1em;">
        <section class="m-box">
    
            <h2>
                Summary of Exam
            </h2>
            <angular-editor   formControlName='SummaryHtml' [config]="editorConfig" style="width: 100%;"></angular-editor>
            <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(GenForm.get('SummaryHtml')!,'Summary of Exam',1241)">Auto Text</button>
            

        </section>
    </div>
    <div class="w100" style="margin-bottom: 1em;">
        <div class="m-box">
            <textarea class="scroller" style="height: 10vh;" formControlName="FreeText"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(GenForm.get('FreeText')!,'Free text',1244)">Auto
            Text</button>
        </div>
    </div>
    <div style="width: 100%;display: inline-flex;">
        <div class="w50 summary-boxHeight summary-referringDr"  style="padding: 0 1em 0 0;height: auto;">
            <section class="m-box" style="height: 95%;" >

                <h2>
                    HMO
                </h2>
                <div class="l-flex-c l-flex-w indicative-fieldset ">
                    <label class="t-label">

                        <input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Leumit
                        </span>

                    </label>

                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Clalit
                        </span>
                    </label>

                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Macabi
                        </span>
                    </label>

                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Meuhedet
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Private
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="הפניקס" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Phoenix
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="כלל" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Clal
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="איילון" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Ayalon
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="הכשרה ביטוח" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Hachshara Insurance
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="מנורה" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Menora
                        </span>
                    </label>
                    <label class="t-label">
                        <input type="radio" formControlName="HMO" value="מגדל" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Migdal
                        </span>
                    </label>
                </div>
                <app-financial-status [examId]="es.examID"></app-financial-status>
                <div class="l-flex-c h100" style="direction: rtl;display: block;">
                    <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em;padding-top: 1%;" *ngIf="GenForm.get('HMO')?.value == 'Macabi' && ls.maccabiExams">
                        קוד טיפול
                        <select class="t-select" formControlName="HMOExamName" (change)="setExamName($event)" style='padding-left:0.5em'>
                            <option value=""></option>
                            <option *ngFor="let examType of getPneumologyExamTypes()" [value]="examType">{{examType}}</option>
                        </select>
                    </div>
                    <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em;padding-top: 1%;" *ngIf="GenForm.get('HMO')?.value != 'Macabi' || !ls.maccabiExams">
                        קוד בדיקה
                        <input class="t-field" formControlName="examCode" style='width: 8em;padding-left:0.5em'>
                    </div>
                    <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em;padding-top: 1%;">
                        מספר הפניה
                        <input class="t-field" formControlName="ReferralNum" style='width: 8em;padding-left:0.5em'>
                    </div>
                    <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                        ת.ז רופא מפנה

                        <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="RefererringDocID">
                   
                    </div>
                    <!-- Clalit routes the result to the referring doctor's license and clinic (the barcodes on its referral) -->
                    <ng-container *ngIf="GenForm.get('HMO')?.value == 'Clalit'">
                        <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                            רישיון רופא מפנה
                            <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="ReferringDocLicense">
                        </div>
                        <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                            גורם שולח (קוד מרפאה)
                            <input type="text" class="t-field" style='width: 8em;padding-left:0.5em' formControlName="ReferringClinicCode">
                        </div>
                        <div class="l-fg1 repeatExamination-text w100" style="font-size: 1.05em;margin-bottom: 1em">
                            שם מרפאה מפנה
                            <input type="text" class="t-field" style='width: 12em;padding-left:0.5em' formControlName="ReferringClinicName">
                        </div>
                    </ng-container>

                </div>
             
            </section>
        </div>
        <div class="w50 summary-referringDr" style="padding: 0 0 0 1em;">
            <section class="m-box padd" style="height: 30%;" (dblclick)="GenForm.get('ReferingDoc')?.setValue(-1)">
                <h2>Referring Doctor</h2>
                <textarea class="fulltext minH4" formControlName="ReferingDoc" ></textarea>
            </section>
            <section class="m-box padd" style="height: 50%;" (dblclick)="GenForm.get('ProcedureResult')?.setValue(null)">
                <h2>Procedure Results</h2>
                <div class="l-flex-c l-flex-w indicative-fieldset h100">
                    <label class="t-label-top">

                        <input type="radio" formControlName="ProcedureResult" value="No Clinical Findings" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            No Clinical Findings
                        </span>

                    </label>

                    <label class="t-label-top">
                        <input type="radio" formControlName="ProcedureResult" value="Clinical Findings" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Clinical Findings
                        </span>
                    </label>

                    <label class="t-label-top">
                        <input type="radio" formControlName="ProcedureResult" value="Urgent Clinical Findings" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Urgent Clinical Findings
                        </span>
                    </label>
                </div>
            </section>
        </div>

</div>
</div>
</ng-container>

</ng-container>